import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editTeam, updateTeamSetting } from "../../services/team.services";
import { UpdateSelectedTeam } from "../../redux/actions/team.actions";
import "./SettingRule.css"; 
import UserSidebar from "../../../components/userSiderbar/userSidebar";

const SettingRule = (props) => {
  const dispatch = useDispatch();
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const user = useSelector((state) => state.auth.user);

  const [initialFormState, setInitialFormState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  // Refs for focusing inputs
  const gamePeriodsRef = useRef(null);
  const periodDurationRef = useRef(null);
  const gapBetweenPeriodsRef = useRef(null);
  const gapBetweenHalvesRef = useRef(null);
  const timeoutsPerHalfRef = useRef(null);
  const timeoutDurationRef = useRef(null);
  const timeoutsInOvertimePeriodRef = useRef(null);
  const overtimePeriodDurationRef = useRef(null);

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    setTimeout(() => {
      setSuccessVisible(false);
    }, 2500);
    dispatch(UpdateSelectedTeam(operatorTeam?._id));
  };

  const handleFormChange = (name, value) => {
    setInitialFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!operatorTeam?.teamId?.game_rules_setting) {
      setInitialFormState(operatorTeam?.teamId?.gameRules);
    } else {
      setInitialFormState(operatorTeam?.teamId?.game_rules_setting);
    }
  }, [operatorTeam?.teamId?.game_rules_setting]);

  const handleSave = async () => {
    try {
      setLoading(true);
      await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          game_rules_setting: initialFormState,
        },
        user?.token
      );
      // toggleSuccessModal();
    } catch (e) {
      console.error("Error at EDIT team's Rule:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleResetToDefault = async () => {
    if (
      window.confirm(
        "Are you sure you want to reset the Team Rules to default?"
      )
    ) {
      try {
        setLoading(true);
        const settingName = "game_rules_setting";
        const teamId = operatorTeam.teamId._id;
        const token = user?.token;
        await updateTeamSetting(settingName, teamId, token);
        toggleSuccessModal();
        dispatch(UpdateSelectedTeam(operatorTeam?._id));
        setInitialFormState([]);
      } catch (e) {
        console.error("Error at Reset Rules:", e);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="settingRuleContainer">
      <UserSidebar />
      <h3 className="ruleName">{initialFormState?.ruleName}
      <br /> <button className="defaultBtn" onClick={handleResetToDefault}>
        Reset to Default
      </button>
      </h3>

      {/* Each input row */}
      <div className="inputRowSettingRule" onClick={() => gamePeriodsRef.current.focus()}>
        <label>Periods per game:</label>
        <input
          ref={gamePeriodsRef}
          type="number"
          value={initialFormState?.gamePeriods || ""}
          onFocus={() => handleFormChange("gamePeriods", "")}
          onChange={(e) =>
            handleFormChange("gamePeriods", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => periodDurationRef.current.focus()}
      >
        <label>Minutes per period:</label>
        <input
          ref={periodDurationRef}
          type="number"
          value={initialFormState?.periodDuration || ""}
          onFocus={() => handleFormChange("periodDuration", "")}
          onChange={(e) =>
            handleFormChange("periodDuration", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => gapBetweenPeriodsRef.current.focus()}
      >
        <label>Minutes between periods:</label>
        <input
          ref={gapBetweenPeriodsRef}
          type="number"
          value={initialFormState?.gapBetweenPeriods || ""}
          onFocus={() => handleFormChange("gapBetweenPeriods", "")}
          onChange={(e) =>
            handleFormChange("gapBetweenPeriods", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => gapBetweenHalvesRef.current.focus()}
      >
        <label>Minutes between halves:</label>
        <input
          ref={gapBetweenHalvesRef}
          type="number"
          value={initialFormState?.gapBetweenHalves || ""}
          onFocus={() => handleFormChange("gapBetweenHalves", "")}
          onChange={(e) =>
            handleFormChange("gapBetweenHalves", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => timeoutsPerHalfRef.current.focus()}
      >
        <label>Timeouts per half:</label>
        <input
          ref={timeoutsPerHalfRef}
          type="number"
          value={initialFormState?.timeoutsPerHalf || ""}
          onFocus={() => handleFormChange("timeoutsPerHalf", "")}
          onChange={(e) =>
            handleFormChange("timeoutsPerHalf", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => timeoutDurationRef.current.focus()}
      >
        <label>Timeout Duration:</label>
        <input
          ref={timeoutDurationRef}
          type="number"
          value={initialFormState?.timeoutDuration || ""}
          onFocus={() => handleFormChange("timeoutDuration", "")}
          onChange={(e) =>
            handleFormChange("timeoutDuration", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => timeoutsInOvertimePeriodRef.current.focus()}
      >
        <label>Timeouts per overtime period:</label>
        <input
          ref={timeoutsInOvertimePeriodRef}
          type="number"
          value={initialFormState?.timeoutsInOvertimePeriod || ""}
          onFocus={() => handleFormChange("timeoutsInOvertimePeriod", "")}
          onChange={(e) =>
            handleFormChange("timeoutsInOvertimePeriod", Number(e.target.value))
          }
        />
      </div>

      <div
        className="inputRowSettingRule"
        onClick={() => overtimePeriodDurationRef.current.focus()}
      >
        <label>Minutes per overtime periods:</label>
        <input
          ref={overtimePeriodDurationRef}
          type="number"
          value={initialFormState?.overtimePeriodDuration || ""}
          onFocus={() => handleFormChange("overtimePeriodDuration", "")}
          onChange={(e) =>
            handleFormChange("overtimePeriodDuration", Number(e.target.value))
          }
        />
      </div>

      <div className="btnRow">
        <button className="cancelBtnSettingRules" onClick={() => props.history.goBack()}>
          Cancel
        </button>
        <button className="saveBtnSettingRules" onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      </div>

      {/* {successVisible && (
        <div className="successOverlay">
          ✅ Default game rules edited successfully!
        </div>
      )} */}
    </div>
  );
};

export default SettingRule;
